import { merge } from 'lodash/object';
import theme from '@guestyci/foundation/theme/defaultTheme';
import Button from '@guestyci/foundation/Button';
import { Col } from '@guestyci/foundation/Layout';
import TextField from '@guestyci/foundation/TextField';
import createStyles from '@guestyci/foundation/esm/createStyles/createStyles';
import useTranslations from '@guestyci/localize/useTranslations/useTranslations';
import config from 'config';
import AppStyle from '../Styles';
import Translations from '../Translations';
import MarketingLoginButton from '../components/MarketingLoginButton';

const useStyles = createStyles(() =>
  merge(AppStyle, {
    root: {
      maxWidth: theme.breakpoints.values.lg,
      margin: '0 auto',
    },
    subhead: {
      fontSize: '1.25rem',
      textAlign: 'center',
      lineHeight: 1.3,
      maxWidth: 500,
    },
  }));

const VerificationError = () => {
  const classes = useStyles();
  const loginPageURL = config.applicationHost;
  const forgotPassPageURL = config.applicationHost.concat('/forgot-password');

  const [buttonLabel] = useTranslations(Translations.step3.buttons);
  const [heading] = useTranslations(Translations.existingEmail.titles);
  const [subheading] = useTranslations(Translations.verificationError.subheading);
  const [resetPasswordButtonLabel] = useTranslations(Translations.existingEmail.buttons);

  const goToForgotPass = () => {
    window.location = forgotPassPageURL;
  };

  return (
    <Col className={classes.root} spacing={10} id="verification-error-container">
      <Col spacing={3}>
        <TextField className={classes.pageHeading} align="center">
          {heading}
        </TextField>
        <TextField className={classes.subhead}>{subheading}</TextField>
      </Col>
      <Col spacing={3} align="center">
        <MarketingLoginButton successLink={loginPageURL}>{buttonLabel}</MarketingLoginButton>
        <Button
          id="verification-error-reset-password-button"
          className={classes.marketingSuccessButtonClear}
          onClick={goToForgotPass}
        >
          {resetPasswordButtonLabel}
        </Button>
      </Col>
    </Col>
  );
};

export default VerificationError;
